
export default {
  secondaryNav: 5,
  mainNav: 10,
  modalDrawer: 100,
  contentLow: 25,
  contentMid: 50,
  contentHigh: 75,
  // MUI Modal is 1300
  popover: 1400,
  dialogs: 2000,
  loadingIndicator: 5000,
}
